export const SkillClassificationStatus = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    NO_CONTENTS_MAPPED: 3,
    SKILL_MODEL_CREATION_TRIGERRED: 4,
    SKILL_CLASSIFICATION_TRIGERRED: 5,
    NO_CONTENTS_AVAILABLE: 6,
    ERROR_GENERATING_SKILL_MODEL: 7,
    ERROR_SUBMITTING_SKILL_FOR_CLASSIFICATION: 8,
    ERROR_SAVING_SKILL_CONTENT_MAPPING: 9,
    ERROR_INDEXING_TO_VECTOR_DB: 10,
    SKILL_MODEL_NOT_AVAILABLE: 11,
    ERROR_CLASSIFYING_SKILL: 12,
    RETRY_LIMIT_EXECEEDED: 13
}